import { RugbyUnionIncidentId } from '@collector/sportsapi-client-legacy'

import { AssignIncidentOnPitchConfig } from '../../../configuration'

const sharedButtonClass =
  'min-h-6! h-6! @sm:min-h-7! @2md:min-h-8! @sm:h-7! @2md:h-8! text-3xs! @sm:text-2xs!'

const scoreButtonClass = `${sharedButtonClass} w-[50%]! @md:w-20! @md:min-w-20!`

export const assignIncidentOnPitchConfig: AssignIncidentOnPitchConfig<RugbyUnionIncidentId> =
  {
    assignIncidentOnPitchIncidents: new Map([
      [
        RugbyUnionIncidentId.ConversionAttempt,
        [
          {
            incidentId: RugbyUnionIncidentId.ConversionGoal,
            variant: 'score',
            name: 'Goal',
            class: scoreButtonClass,
          },
          {
            incidentId: RugbyUnionIncidentId.ConversionMissed,
            variant: 'missed',
            name: 'Missed',
            class: scoreButtonClass,
          },
        ],
      ],
      [
        RugbyUnionIncidentId.PenaltyAwarded,
        [
          {
            incidentId: RugbyUnionIncidentId.PenaltyKickGoal,
            variant: 'score',
            name: 'Goal',
            class: scoreButtonClass,
          },
          {
            incidentId: RugbyUnionIncidentId.PenaltyKickMissed,
            variant: 'missed',
            name: 'Missed',
            class: scoreButtonClass,
          },
          {
            incidentId: RugbyUnionIncidentId.Kick,
            variant: 'default',
            name: 'Kick',
            class: scoreButtonClass,
          },
        ],
      ],
      [
        RugbyUnionIncidentId.Cards,
        [
          {
            incidentId: RugbyUnionIncidentId.YellowCard,
            name: 'Yellow',
            class: `${sharedButtonClass} min-w-10! w-10! bg-warning-5! border-warning-5! hover:bg-warning-7! hover:border-warning-7!`,
          },
          {
            incidentId: RugbyUnionIncidentId.RedCard,
            name: 'Red',
            class: `${sharedButtonClass} min-w-10! w-10! bg-error-5! border-error-5! hover:bg-error-7! hover:border-error-7!`,
          },
          {
            incidentId: RugbyUnionIncidentId.OrangeCard,
            name: 'Orange',
            class: `${sharedButtonClass} min-w-11! w-11! bg-current-team-home-5! border-current-team-home-5! hover:bg-current-team-home-7! hover:border-current-team-home-7!`,
          },
        ],
      ],
    ]),
  }
